module.exports = __webpack_public_path__ + "static/img/goldentoad_esp.118f12a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/goldentoad_esp.png
// module id = /oSW
// module chunks = 1